var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import classNames from "classnames";
import React from "react";
import { Heading } from "@riseart/common";
import { Card } from "../card/Card";
import { CardMedia } from "../card/media/CardMedia";
import { CardContent } from "../card/content/Content";
import { CardContentOverlay } from "../card/content/Overlay";
import { cardEditorialCls, cardEditorialLargeCls, cardEditorialHorizontalCls, cardEditorialContentWrapperCls, cardEditorialTitleCls, cardEditorialSubtitleCls, cardEditorialDescriptionCls, cardEditorialExtraCls } from "./Card.less";
function CardEditorial(_ref) {
  var className = _ref.className, layout = _ref.layout, size = _ref.size, title = _ref.title, subTitle = _ref.subTitle, _ref$description = _ref.description, description = _ref$description === void 0 ? null : _ref$description, overlay = _ref.overlay, extra = _ref.extra, children = _ref.children;
  return /* @__PURE__ */ React.createElement(Card, {
    className: classNames(cardEditorialCls, layout === "horizontal" && cardEditorialHorizontalCls, size === "large" && cardEditorialLargeCls, className)
  }, children ? /* @__PURE__ */ React.createElement(CardMedia, null, children) : null, /* @__PURE__ */ React.createElement(CardContent, null, overlay ? /* @__PURE__ */ React.createElement(CardContentOverlay, null, overlay) : null, /* @__PURE__ */ React.createElement("div", {
    className: cardEditorialContentWrapperCls
  }, /* @__PURE__ */ React.createElement("div", null, subTitle ? /* @__PURE__ */ React.createElement("div", {
    className: cardEditorialSubtitleCls
  }, subTitle) : null, title ? /* @__PURE__ */ React.createElement(Heading, {
    tag: "h3",
    level: 5,
    className: cardEditorialTitleCls
  }, title) : null, description || extra ? /* @__PURE__ */ React.createElement("div", {
    className: cardEditorialDescriptionCls
  }, extra ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", {
    className: cardEditorialExtraCls
  }, extra), description ? /* @__PURE__ */ React.createElement(React.Fragment, null, " | ") : null) : null, description) : null))));
}
__name(CardEditorial, "CardEditorial");
export {
  CardEditorial
};
